// removed by extract-text-webpack-plugin
module.exports = {"icon":"ProductionLeadTime__icon__e942c342","title":"ProductionLeadTime__title__e942c342","info":"ProductionLeadTime__info__e942c342"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Shipping/ProductionLeadTime.scss
// module id = 1836
// module chunks = 4 14